import React from "react";
import LoginForm from "../components/login/LoginForm"

function LoginPage() {
    return (
        <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-deepNavy via-navy to-deepNavy flex items-center justify-center p-8">
            
            <div className="absolute top-[-200px] left-[-100px] h-[500px] w-[500px] rounded-full bg-blue-500/20 blur-[150px]" />

            <div className="absolute bottom-[-200px] right-[-100px] h-[500px] w-[500px] rounded-full bg-orange-500/10 blur-[150px]" />

            <div className="relative flex h-[450px] md:h-[700px] w-full max-w-5xl overflow-hidden rounded-[40px] bg-white shadow-2xl">
                <LoginForm />
            </div>  

            <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-center text-sm text-white/70 md:hidden flex flex-col gap-2">
                <p>Copyrights &copy; Dockyard Total Solutions (PVT) LTD</p>
                <p>All rights reserved.</p>
            </p>  
        </div>
    )
}

export default LoginPage;